module.exports = __webpack_public_path__ + "static/round-31886be8cb95ad64541fd8e1440d74f7.gif";